export const safeParseJSON = (content: unknown): unknown => {
  if (typeof content !== 'string') return content;

  try {
    const trimmed = content.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      return JSON.parse(trimmed);
    }
    return content.replace(/^"|"$/g, '');
  } catch {
    return content;
  }
};

export const parseContentItem = <T>(content: unknown): T | null => {
  if (!content) return null;

  if (typeof content === 'string') {
    try {
      return JSON.parse(content) as T;
    } catch {
      return content as T;
    }
  }

  return content as T;
};

export const sanitizeHTML = (html: string): string => {
  if (!html) return '';
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
};

export const escapeHTML = (text: string): string => {
  if (!text) return '';
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  return text.replace(/[&<>"'/]/g, (char) => map[char]);
};

export const isValidURL = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const formatImageURL = (url: string, width?: number): string => {
  if (!url) return '';

  if (url.includes('unsplash.com') && width) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}w=${width}`;
  }

  return url;
};
